import { useContext } from "react";
import { VideoContext } from "../VideoContext";
import { VideoLessonDetails } from "../VideoProvider";
import QuizContent from "./Quiz/QuizContent";
import VideoLessonContent from "./Lesson/VideoLessonContent";
import Exercise from "./Exercise/Exercise";

export default function RightPanel({ lessonDetails }: { lessonDetails: VideoLessonDetails }) {
  const { inLessonMode, inQuizMode, inExerciseMode } = useContext(VideoContext);

  if (inLessonMode) {
    return <VideoLessonContent lessonDetails={lessonDetails} />;
  }

  if (inQuizMode) {
    return <QuizContent />;
  }

  if (inExerciseMode) {
    return <Exercise exercise={lessonDetails.experiment} variant={lessonDetails.variant} />;
  }
}
